/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChatDocumentResponseDto } from '../models';
// @ts-ignore
import type { ChatDocumentsResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
/**
 * ChatDocumentsApi - axios parameter creator
 * @export
 */
export const ChatDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the file from S3 and its chunks from the vector store.
         * @summary Delete a document attached to a chat (owner only)
         * @param {string} chatId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatDocument: async (chatId: string, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('deleteChatDocument', 'chatId', chatId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteChatDocument', 'documentId', documentId)
            const localVarPath = `/api/v1/chats/{chatId}/documents/{documentId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List documents attached to a chat (owner only)
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDocuments: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('getChatDocuments', 'chatId', chatId)
            const localVarPath = `/api/v1/chats/{chatId}/documents`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * File is stored in S3; text is extracted and embedded asynchronously into the isolated document vector store, scoped to this chat. Allowed types: TXT, PDF, DOCX, XLSX. Max 20 MB.
         * @summary Upload a document and attach it to a chat (owner only)
         * @param {string} chatId 
         * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChatDocument: async (chatId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('uploadChatDocument', 'chatId', chatId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadChatDocument', 'file', file)
            const localVarPath = `/api/v1/chats/{chatId}/documents`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatDocumentsApi - functional programming interface
 * @export
 */
export const ChatDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the file from S3 and its chunks from the vector store.
         * @summary Delete a document attached to a chat (owner only)
         * @param {string} chatId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChatDocument(chatId: string, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChatDocument(chatId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatDocumentsApi.deleteChatDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List documents attached to a chat (owner only)
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatDocuments(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatDocuments(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatDocumentsApi.getChatDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * File is stored in S3; text is extracted and embedded asynchronously into the isolated document vector store, scoped to this chat. Allowed types: TXT, PDF, DOCX, XLSX. Max 20 MB.
         * @summary Upload a document and attach it to a chat (owner only)
         * @param {string} chatId 
         * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadChatDocument(chatId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDocumentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadChatDocument(chatId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatDocumentsApi.uploadChatDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatDocumentsApi - factory interface
 * @export
 */
export const ChatDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatDocumentsApiFp(configuration)
    return {
        /**
         * Removes the file from S3 and its chunks from the vector store.
         * @summary Delete a document attached to a chat (owner only)
         * @param {string} chatId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChatDocument(chatId: string, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteChatDocument(chatId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List documents attached to a chat (owner only)
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatDocuments(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatDocumentsResponseDto> {
            return localVarFp.getChatDocuments(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * File is stored in S3; text is extracted and embedded asynchronously into the isolated document vector store, scoped to this chat. Allowed types: TXT, PDF, DOCX, XLSX. Max 20 MB.
         * @summary Upload a document and attach it to a chat (owner only)
         * @param {string} chatId 
         * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadChatDocument(chatId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ChatDocumentResponseDto> {
            return localVarFp.uploadChatDocument(chatId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatDocumentsApi - interface
 * @export
 * @interface ChatDocumentsApi
 */
export interface ChatDocumentsApiInterface {
    /**
     * Removes the file from S3 and its chunks from the vector store.
     * @summary Delete a document attached to a chat (owner only)
     * @param {string} chatId 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatDocumentsApiInterface
     */
    deleteChatDocument(chatId: string, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary List documents attached to a chat (owner only)
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatDocumentsApiInterface
     */
    getChatDocuments(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatDocumentsResponseDto>;

    /**
     * File is stored in S3; text is extracted and embedded asynchronously into the isolated document vector store, scoped to this chat. Allowed types: TXT, PDF, DOCX, XLSX. Max 20 MB.
     * @summary Upload a document and attach it to a chat (owner only)
     * @param {string} chatId 
     * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatDocumentsApiInterface
     */
    uploadChatDocument(chatId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ChatDocumentResponseDto>;

}

/**
 * ChatDocumentsApi - object-oriented interface
 * @export
 * @class ChatDocumentsApi
 * @extends {BaseAPI}
 */
export class ChatDocumentsApi extends BaseAPI implements ChatDocumentsApiInterface {
    /**
     * Removes the file from S3 and its chunks from the vector store.
     * @summary Delete a document attached to a chat (owner only)
     * @param {string} chatId 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatDocumentsApi
     */
    public deleteChatDocument(chatId: string, documentId: number, options?: RawAxiosRequestConfig) {
        return ChatDocumentsApiFp(this.configuration).deleteChatDocument(chatId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List documents attached to a chat (owner only)
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatDocumentsApi
     */
    public getChatDocuments(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatDocumentsApiFp(this.configuration).getChatDocuments(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * File is stored in S3; text is extracted and embedded asynchronously into the isolated document vector store, scoped to this chat. Allowed types: TXT, PDF, DOCX, XLSX. Max 20 MB.
     * @summary Upload a document and attach it to a chat (owner only)
     * @param {string} chatId 
     * @param {File} file Document file (TXT, PDF, DOCX, XLSX)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatDocumentsApi
     */
    public uploadChatDocument(chatId: string, file: File, options?: RawAxiosRequestConfig) {
        return ChatDocumentsApiFp(this.configuration).uploadChatDocument(chatId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

